import { Action } from 'infra/types'
import {
  IFetchOrderGroupSummaryActionPayload,
  IFetchOrderSummaryActionPayload,
  IOrderSummaryFormattedData,
  IOrderSummaryDateFilter,
  IOrderSummaryGroupFormattedData,
  IFetchOrderGroupSummaryDownlaodActionPayload,
  IOrderSummaryItemLevelStats,
  IOrderSummaryStats,
  IOrderSummaryItemLevelStatsV2
} from './orderSummary.types'

export const OrderSummaryActions = {
  GET_ORDER_SUMMARY: 'orderSummary/GET_ORDER_SUMMARY',
  SET_ORDER_SUMMARY: 'orderSummary/SET_ORDER_SUMMARY',
  SET_ORDER_SUMMARY_LIST_ITEMS: 'orderSummary/SET_ORDER_SUMMARY_LIST_ITEMS',

  GET_ORDER_GROUP_SUMMARY: 'GET_ORDER_GROUP_SUMMARY',
  GET_ORDER_GROUP_SUMMARY_SUCCESS: 'GET_ORDER_GROUP_SUMMARY_SUCCESS',

  SET_SUMMARY_ACTIVE_FILTER: 'orderSummary/SET_SUMMARY_ACTIVE_FILTER',

  SET_DRAWER: 'orderSummary/SET_DRAWER',

  SET_LOADER: 'orderSummary/SET_LOADER',
  DOWNLOAD_ORDER_SUMMARY: 'orderSummary/DOWNLOAD_ORDER_SUMMARY',
  GET_OVERALL_ORDER_GROUP_SUMMARY: 'orderSummary/GET_OVERALL_ORDER_GROUP_SUMMARY',
  GET_OVERALL_ORDER_GROUP_SUMMARY_SUCCESS: 'orderSummary/GET_OVERALL_ORDER_GROUP_SUMMARY_SUCCESS',
  DOWNLOAD_OVERALL_ORDER_GROUP_SUMMARY: 'orderSummary/DOWNLOAD_OVERALL_ORDER_GROUP_SUMMARY'
}

export const getOrderSummaryAction = (
  payload: IFetchOrderSummaryActionPayload
): Action<IFetchOrderSummaryActionPayload> => ({
  type: OrderSummaryActions.GET_ORDER_SUMMARY,
  payload
})
export const setOrderSummary = (payload: IOrderSummaryStats): Action<IOrderSummaryStats> => ({
  type: OrderSummaryActions.SET_ORDER_SUMMARY,
  payload
})
export const setOrderSummaryListItems = (
  payload: IOrderSummaryFormattedData[]
): Action<IOrderSummaryFormattedData[]> => ({
  type: OrderSummaryActions.SET_ORDER_SUMMARY_LIST_ITEMS,
  payload
})

export const getOrderGroupSummaryAction = (
  payload: IFetchOrderGroupSummaryActionPayload
): Action<IFetchOrderGroupSummaryActionPayload> => ({
  type: OrderSummaryActions.GET_ORDER_GROUP_SUMMARY,
  payload
})

export const getOrderGroupSummaryActionSuccess = (
  payload: IOrderSummaryGroupFormattedData
): Action<IOrderSummaryGroupFormattedData> => ({
  type: OrderSummaryActions.GET_ORDER_GROUP_SUMMARY_SUCCESS,
  payload
})

export const setDrawerAction = (payload: {
  id: string
  value: boolean
}): Action<{ id: string; value: boolean }> => ({
  type: OrderSummaryActions.SET_DRAWER,
  payload
})

export const setLoaderAction = (payload: {
  id: string
  value: boolean
}): Action<{ id: string; value: boolean }> => ({
  type: OrderSummaryActions.SET_LOADER,
  payload
})

export const setSummaryActiveFilter = (
  filter: IOrderSummaryDateFilter | null
): Action<IOrderSummaryDateFilter | null> => ({
  type: OrderSummaryActions.SET_SUMMARY_ACTIVE_FILTER,
  payload: filter
})

export const downloadOrderSummary = (
  payload: IFetchOrderGroupSummaryDownlaodActionPayload
): Action<IFetchOrderGroupSummaryDownlaodActionPayload> => ({
  type: OrderSummaryActions.DOWNLOAD_ORDER_SUMMARY,
  payload
})

export const setOrderSummaryModalsAction = (payload: {
  modalName: 'orderSummaryDownload'
  status: boolean
}): Action<{ modalName: 'orderSummaryDownload'; status: boolean }> => ({
  type: OrderSummaryActions.SET_DRAWER,
  payload
})

export const getOverallOrderGroupSummaryAction = (
  payload: IFetchOrderGroupSummaryActionPayload
): Action<IFetchOrderGroupSummaryActionPayload> => ({
  type: OrderSummaryActions.GET_OVERALL_ORDER_GROUP_SUMMARY,
  payload
})

export const getOverallOrderGroupSummarySuccessAction = (payload: {
  data: IOrderSummaryItemLevelStatsV2[]
  page: number
  limit: number
  totalItems: number
}): Action<{
  data: IOrderSummaryItemLevelStatsV2[]
  page: number
  limit: number
  totalItems: number
}> => ({
  type: OrderSummaryActions.GET_OVERALL_ORDER_GROUP_SUMMARY_SUCCESS,
  payload
})

export const downloadOverallGroupSummaryAction = (): Action<null> => ({
  type: OrderSummaryActions.DOWNLOAD_OVERALL_ORDER_GROUP_SUMMARY,
  payload: null
})
